<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'WanStatusList' }"
                ><i class="fas fa-chevron-left"></i></router-link
              >Wan Status
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Wan Status</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="WanStatus">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools"></div>
            </div>
            <div class="card-body pb-2">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-row">
                    <div class="col-md-12 form-group required">
                      <label class="control-label">Mac</label>
                      <input
                        type="text"
                        id="ap_wi_mac"
                        name="ap_wi_mac"
                        v-bind:class="{ 'has-error': errors.has('ap_wi_mac') }"
                        v-validate="'required'"
                        v-model="value.ap_wi_mac"
                        class="form-control ap_wi_mac"
                        placeholder="Mac"
                      />
                      <div
                        class="help text-danger"
                        v-show="errors.has('ap_wi_mac')"
                      >
                        {{ errors.first('ap_wi_mac') }}
                      </div>
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN Status</label>
                      <input
                        type="text"
                        id="pstatus"
                        name="pstatus"
                        v-model="value.pstatus"
                        class="form-control pstatus"
                        placeholder="PWAN Status"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN Protocol</label>
                      <input
                        type="text"
                        id="pproto"
                        name="pproto"
                        v-model="value.pproto"
                        class="form-control pproto"
                        placeholder="PWAN Protocol"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN IP</label>
                      <input
                        type="text"
                        id="pip"
                        name="pip"
                        v-model="value.pip"
                        class="form-control pip"
                        placeholder="PWAN IP"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN Subnet Mask</label>
                      <input
                        type="text"
                        id="psubnetmask"
                        name="psubnetmask"
                        v-model="value.psubnetmask"
                        class="form-control psubnetmask"
                        placeholder="PWAN Subnet Mask"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN Gateway</label>
                      <input
                        type="text"
                        id="pgateway"
                        name="pgateway"
                        v-model="value.pgateway"
                        class="form-control pgateway"
                        placeholder="PWAN Gateway"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN DNS</label>
                      <input
                        type="text"
                        id="pdns"
                        name="pdns"
                        v-model="value.pdns"
                        class="form-control pdns"
                        placeholder="PWAN DNS"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN MAC</label>
                      <input
                        type="text"
                        id="pmac"
                        name="pmac"
                        v-model="value.pmac"
                        class="form-control pmac"
                        placeholder="PWAN MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">PWAN Interface</label>
                      <input
                        type="text"
                        id="pinterface"
                        name="pinterface"
                        v-model="value.pinterface"
                        class="form-control pinterface"
                        placeholder="PWAN Interface"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Enable</label>
                      <input
                        type="text"
                        id="senable"
                        name="senable"
                        v-model="value.senable"
                        class="form-control senable"
                        placeholder="SWAN Enable"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Status</label>
                      <input
                        type="text"
                        id="sstatus"
                        name="sstatus"
                        v-model="value.sstatus"
                        class="form-control sstatus"
                        placeholder="SWAN Status"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Protocol</label>
                      <input
                        type="text"
                        id="sproto"
                        name="sproto"
                        v-model="value.sproto"
                        class="form-control sproto"
                        placeholder="SWAN Protocol"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN IP</label>
                      <input
                        type="text"
                        id="sip"
                        name="sip"
                        v-model="value.sip"
                        class="form-control sip"
                        placeholder="SWAN IP"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Subnet Mask</label>
                      <input
                        type="text"
                        id="ssubnetmask"
                        name="ssubnetmask"
                        v-model="value.ssubnetmask"
                        class="form-control ssubnetmask"
                        placeholder="SWAN Subnet Mask"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Gateway</label>
                      <input
                        type="text"
                        id="sgateway"
                        name="sgateway"
                        v-model="value.sgateway"
                        class="form-control sgateway"
                        placeholder="SWAN Gateway"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN DNS</label>
                      <input
                        type="text"
                        id="sdns"
                        name="sdns"
                        v-model="value.sdns"
                        class="form-control sdns"
                        placeholder="SWAN DNS"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN MAC</label>
                      <input
                        type="text"
                        id="smac"
                        name="smac"
                        v-model="value.smac"
                        class="form-control smac"
                        placeholder="SWAN MAC"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">SWAN Interface</label>
                      <input
                        type="text"
                        id="sinterface"
                        name="sinterface"
                        v-model="value.sinterface"
                        class="form-control sinterface"
                        placeholder="SWAN Interface"
                      />
                    </div>
                    <div class="col-md-6 form-group">
                      <label class="control-label">Uptime</label>
                      <input
                        type="text"
                        id="uptime"
                        name="uptime"
                        v-model="value.uptime"
                        class="form-control uptime"
                        placeholder="Uptime"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'WanStatusForm',
  metaInfo: {
    title: 'Wan Status | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/wan_status'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/wan_status/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'WanStatusList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/wan_status/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(error => {
            console.log(error.response)
          })
      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
